import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconSearchComponent = ({ color = petrol.main, strokeWidth = 1.5, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={strokeWidth}>
      <path
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};

IconSearchComponent.displayName = 'IconSearch';
const IconSearch = memo(IconSearchComponent);

export default IconSearch;
